<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#users-s"></use></svg>
  Tidligere adgangsgrupper
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <adm-loading-spinner [loading$]="loading$"></adm-loading-spinner>

  <table
    mat-table
    [dataSource]="dataSource"
    [class.loading-blur]="loading$ | async"
    [class.loading-blur--done]="(loading$ | async) === false"
    class="previous-access-groups-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="col">Navn</th>
      <td mat-cell *matCellDef="let accessGroup" class="row name-cell">
        <span class="ellipsis" okEllipsisTooltip>{{ accessGroup.name }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="from">
      <th mat-header-cell *matHeaderCellDef class="col">Fra</th>
      <td mat-cell *matCellDef="let accessGroup" class="row">
        {{ accessGroup.activeFrom | date: 'shortDate' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="to">
      <th mat-header-cell *matHeaderCellDef class="col">Til</th>
      <td mat-cell *matCellDef="let accessGroup" class="row">
        {{ getTo(accessGroup) | date: 'shortDate' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="timeLimited">
      <th mat-header-cell *matHeaderCellDef class="col">Tidsbegrænset</th>
      <td mat-cell *matCellDef="let accessGroup" class="row">
        @if (accessGroup.accessType === accessGroupUserType.TimeLimited) {
          <span> Ja </span>
        } @else {
          <span> Nej </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="discount">
      <th mat-header-cell *matHeaderCellDef class="col">Rabat</th>
      <td mat-cell *matCellDef="let accessGroup" class="row">
        @if (accessGroup.discountType === discountType.FixedAmount) {
          {{ accessGroup.discountAmount | dkCurrency }}
        }
        @if (accessGroup.discountType === discountType.Percentages) {
          {{ accessGroup.discountAmount | number: '1.2-2' }}%
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let rowData; columns: displayColumns"></tr>
  </table>

  <mat-paginator
    #paginator
    class="paginator margin--top-l"
    [style.visibility]="totalCount ? 'visible' : 'hidden'"
    [pageIndex]="currentPage"
    [pageSize]="pagingOptions.pageSize"
    [length]="totalCount"
    [pageSizeOptions]="pagingOptions.pageSizeOptions"
    (page)="onPageChanged($event)"
    color="accent"
    [disabled]="(loading$ | async) === true" />
</mat-dialog-content>
<mat-dialog-actions>
  <div class="unit-identifier">
    <span>Bruger:</span>
    {{ chargingUser.name }}
  </div>
  <button type="button" mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
